module.exports = __webpack_public_path__ + "img/android.fbc452f.png";